import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
  selector: "app-google-storage-preview",
  templateUrl: "./google-storage-preview.component.html",
  styleUrls: ["./google-storage-preview.component.scss"],
})
export class GoogleStoragePreviewComponent {
  private _signedUrl: string | null = null;

  @Input()
  set signedUrl(value: string | null) {
    this._signedUrl = value;
    this.previewUrl = value
      ? this.sanitizer.bypassSecurityTrustResourceUrl(value)
      : null;
  }

  get signedUrl(): string | null {
    return this._signedUrl;
  }

  @Input() title = "Vista previa del documento";

  previewUrl: SafeResourceUrl | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer,
  ) {}
}
